import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { teamData, socialMedia } from '../data/mock';
import { Flag, Calendar, MapPin, Trophy, ChevronDown, ChevronUp } from 'lucide-react';

const raceRecaps = [
  {
    id: 1,
    title: "Round 1 Internazionali d'Italia",
    date: "31 gennaio 2026",
    location: "Alghero",
    category: "Internazionali",
    riders: "Douwe Van Mechgelen e Francesco Quintili",
    images: [
      "/media/5haj62jg_Francesco-Quintili-2026-INT.-d-Italia-MX-Alghero_05.jpg",
      "/media/c5096g5b_Douwe-Van-Mechgelen-2026-INT.-d-Italia-MX-Alghero_05.jpg"
    ],
    summary: "Il rinnovato Seven Motorsport TM Factory Support guidato da Simone Paolucci, inaugura ufficialmente la propria stagione prendendo parte alla prima gara degli Internazionali d'Italia Motocross, presso il tracciato sardo di Alghero, in provincia di Sassari. Oltre ad una nuova moto e, naturalmente una nuova livrea, il team si presenta anche con due nuovi piloti: il belga Douwe Van Mechgelen nella classe MX2 e l'italiano Francesco Quintili nella classe 125, quest'ultimo al suo debutto in gare di caratura internazionale. Dopo la pioggia incessante del sabato, domenica mattina, il fondo sabbioso del 'Lazzaretto' si presenta molto fangoso ed impegnativo. Al termine della sessione di prove cronometrate della MX2, Van Mechgelen si classifica sesto del gruppo 1. Nella prima manche, una buona partenza ed un buon ritmo di gara gli consegnano il 13esimo posto finale. Nella seconda manche, una caduta subito dopo il 'via' lo vede tra gli ultimi, al termine del primo giro. Dopo quattro tornate, il belga opta per il ritiro. Con un solo risultato utile ai fini della classifica generale, Douwe Van Mechgelen si classifica 18esimo. Nella classe 125, Francesco Quintili supera le cronometrate ottenendo il 38esimo tempo. Nelle due manche di gara, nonostante un tracciato difficile ed insidioso, Francesco porta a termine le manche ottenendo un 28esimo ed un 31esimo posto. In classifica generale, si posiziona 33esimo. Per il secondo ed ultimo round degli Internazionali d'Italia Motocross, l'appuntamento è previsto per l'8 febbraio quando team e piloti si ritroveranno presso il 'Tazio Nuvolari' di Mantova.",
    position: "P.18 & P.33",
    highlights: [
      "Douwe: Qualy P.6 • Gara 1 P.13 • Gara 2 DNF • Overall P.18",
      "Quintili: Qualy P.38 • Gara 1 P.28 • Gara 2 P.31 • Overall P.33",
      "Debutto ufficiale stagione 2026 con nuova livrea"
    ]
  },
  {
    id: 2,
    title: "Round 2 Internazionali d'Italia",
    date: "7 febbraio 2026",
    location: "Mantova",
    category: "Internazionali",
    riders: "Douwe Van Mechgelen e Francesco Quintili",
    images: [
      "/media/zkrdc1qx_Douwe-Van-Mechgelen-2026-INT.-d-Italia-MX-Mantova_03.jpg",
      "/media/q38qtlgk_Francesco-Quintili-2026-INT.-d-Italia-MX-Mantova_05.jpg"
    ],
    summary: "Il round finale degli Internazionali d'Italia Motocross ha come sede il 'Tazio Nuvolari' di Mantova, tracciato di caratura internazionale teatro di numerose prove del campionato del mondo motocross. A vestire i colori del Seven Motorsport TM Factory Support in pista, ci sono il belga Douwe Van Mechgelen #4 e l'italiano Francesco Quintili #320. Il primo schierato nella classe MX2, il secondo nella classe 125. Domenica mattina la nebbia avvolge il tracciato mantovano: a peggiorare la situazione, un tracciato alquanto fangoso a causa della copiosa pioggia caduta sino alla giornata di venerdì. Nella classe 125 Francesco Quintili non riesce a fare meglio del 26esimo tempo e per lui, il weekend di gara termina con largo anticipo non qualificandosi alla gara. Nella classe MX2 invece, Douwe Van Mechgelen fa segnare il 14esimo tempo del gruppo 2 e conquista la 27esima postazione in griglia di partenza. Nelle due manche di gara però, la fortuna non è dalla parte del belga. Nella prima, dopo una discreta partenza, una solida rimonta gli consegna il 12esimo posto ma le condizioni estreme di visibilità lo costringono a fare a meno degli occhiali. A pochi giri dal termine una pietra lo colpisce nell'occhio destro. Terminata la prima manche in 12esima piazza, il belga prova a prendere il via della seconda ma dopo poche tornate si ritira per problemi alla vista che non gli permettono di guidare in sicurezza. Diciannovesimo di giornata, conclude gli Internazionali d'Italia Motocross con un 16esimo posto. Per rivedere in pista il Seven Motorsport TM Factory Support bisognerà attendere il 15 marzo quando team e piloti si ritroveranno presso il circuito 'South Milano' di Ottobiano per la prova di apertura del Campionato Italiano MX PRO Prestige MX1/MX2. Nello stesso fine settimana, Francesco Quintili inizierà la sua avventura nel Campionato Italiano MX Junior affrontando la prima Selettiva Zona Sud sul tracciato siciliano di Partanna, in provincia di Trapani.",
    position: "P.19 & DNQ",
    highlights: [
      "Douwe: Qualy P.14 • Gara 1 P.12 • Gara 2 DNF • Overall P.19",
      "Quintili: Qualy P.26 • Not Qualified for the Races",
      "Condizioni estreme di nebbia e fango a Mantova"
    ]
  },
  {
    id: 3,
    title: "Round 1 Campionato Italiano Prestige MX2",
    date: "14 marzo 2026",
    location: "Ottobiano",
    category: "Prestige MX2",
    riders: "Douwe Van Mechgelen",
    images: [
      "/media/rqwg38pi_Douwe-Van-Mechgelen-2026-CI-MX-PRO-Prestige-MX1-MX2-Ottobiano_09.jpg",
      "/media/kmoaalo7_Douwe-Van-Mechgelen-2026-CI-MX-PRO-Prestige-MX1-MX2-Ottobiano_05.jpg"
    ],
    summary: "Come tracciato per aprire la nuova stagione agonistica del Campionato Italiano MX PRO Prestige MX1-MX2, la Federazione Motociclistica Italiana sceglie il catino internazionale dell'Ottobiano Motorsport, situato nelle lande del paesino lombardo in provincia di Pavia. Con il meteo però non si può fare niente e, il fine settimana del 14 e 15 marzo, la pioggia fa da padrona, rendendo il circuito un vero e proprio inferno di acqua e fango e condizionando pesantemente il regolare svolgimento della manifestazione, ridotta ad una sola manche per classe. A rappresentare il Seven Motorsport TM Factory Supported, nella classe MX2 Elite c'è il belga Douwe Van Mechgelen #16, già visto in azione nei due round degli Internazionali d'Italia MX.",
    position: "P.10",
    highlights: [
      "Douwe: Qualy P.3 • Gara 1 P.10 • Overall P.10",
      "Gara ridotta ad una sola manche per maltempo",
      "Debutto nel Campionato Italiano Prestige MX2"
    ]
  },
  {
    id: 4,
    title: "Round 1 EMX125 & EMX250",
    date: "21 marzo 2026",
    location: "Almonte, Spagna",
    category: "EMX",
    riders: "Douwe Van Mechgelen e Francesco Quintili",
    images: [
      "/media/qemn3jeb_Francesco-Quintili-2026-EMX125-Round-of-Andalucia-Almonte_01.jpg",
      "/media/n7rbzqsg_Douwe-Van-Mechgelen-2026-EMX250-Round-of-Andalucia-Almonte_03.jpg"
    ],
    summary: "Con il ritorno in Europa del FIM Motocross World Championship, dopo la tappa di apertura in Argentina, prendono il via anche i campionati europei. Il Seven Motorsport TM Factory Supported dà il via alla sua stagione europea schierando il belga Douwe Van Mechgelen #18 nella EMX250 e l'italiano Francesco Quintili #320, al suo debutto in una gara internazionale, nella EMX125. Il fine settimana di Douwe inizia con un piccolo infortunio: nelle prove libere si stira un pollice e, per tutto il weekend, è costretto a guidare in condizioni non ottimali. Chiusa la prima sessione con un 20esimo tempo del Gruppo A, il belga migliora leggermente in qualifica ottenendo il 18esimo tempo. Nella prima manche compie solo quattro giri per poi ritirarsi. Nella seconda manche, dalla 35esima posizione iniziale, giunge al traguardo 31esimo. Un inizio di stagione non dei migliori quello del belga che si ritrova 33esimo in classifica generale. Anche per Francesco Quintili, il debutto nel Campionato EMX125, non è dei più semplici. Assegnato al gruppo A, conclude sia le prove libere che le qualifiche in 28esima piazza e non si qualifica per la gara. Entrambi i ragazzi ci riproveranno il prossimo fine settimana dove in occasione del GP di Svizzera sul tracciato di Frauenfeld, si terrà anche il secondo round di entrambi i campionati: EMX125 ed EMX250.",
    position: "P.33 & DNQ",
    highlights: [
      "Douwe: Qualy P.18 • Race 1 DNF • Race 2 P.31 • Overall P.33",
      "Francesco: Qualy P.28 • Not Qualified for the Races",
      "Debutto europeo EMX per entrambi i piloti"
    ]
  },
  {
    id: 5,
    title: "Round 2 EMX125 & EMX250",
    date: "28 marzo 2026",
    location: "Frauenfeld, Svizzera",
    category: "EMX",
    riders: "Douwe Van Mechgelen e Francesco Quintili",
    images: [
      "/media/ete9xho0_Douwe-Van-Mechgelen-2026-EMX250-Round-of-Switzerland-Frauenfeld_03.jpg",
      "/media/vvoklobd_Francesco-Quintili-2026-EMX125-Round-of-Switzerland-Frauenfeld_04.jpg"
    ],
    summary: "Senza fine settimana di sosta, il FIM Motocross World Championship si trasferisce dalla Spagna alla Svizzera e anche i ragazzi dei campionati europei si prendono parte all'evento confrontandosi sul duro e tortuoso tracciato svizzero di Frauenfeld, sede dell'MXGP della Svizzera. Il fine settimana si presenta difficile sin dall'inizio per il Seven Motorsport TM Factory Supported perché nella EMX250, il belga Douwe Van Mechgelen #18 decide di prendere parte all'evento nonostante l'infortunio al pollice patito in Spagna. Nella EMX125, Francesco Quintili #320 ci riprova e continua a fare esperienza ma le condizioni meteo e del tracciato, fangoso e molto scavato, non lo aiutano nell'impresa. Il fine settimana di Francesco si ferma ancora una volta al termine delle prove cronometrate. Il laziale non riesce a trovare il giusto 'feeling' nelle due sessioni per potersi migliorare e con il 31esimo tempo non si qualifica per la gara. Nella EMX250 Douwe ottiene il 19esimo tempo nelle libere del suo gruppo ma nelle cronometrate, migliora sensibilmente la sua prestazione; grazie ad un 13esimo tempo guadagna l'accesso alla gara. Nella prima manche, una caduta in partenza lo relega in fondo al gruppo e al termine del primo giro, si ritrova 36esimo. La rimonta intrapresa sin dal secondo passaggio e conclusasi con la bandiera a scacchi, gli consegna la 25esima piazza. Nella seconda manche della domenica mattina, il tracciato si presenta decisamente più fangoso ed impegnativo per i piloti. Ancora una volta una caduta costringe il belga a rimontare tra le mille difficoltà. Completate le quattordici tornate, Douwe chiude 26esimo e a fine giornata, si ritrova 30esimo della classifica generale. Per i prossimi due appuntamenti il FIM Motocross World Championship farà tappa in Italia con l'MXGP della Sardegna e l'MXGP del Trentino. In entrambi i round è prevista un prova dei Campionati EMX125 ed EMX250, perciò, il Seven Motorsport TM Factory Supported, sarà nuovamente in pista con i suoi due piloti Douwe Van Mechgelen e Francesco Quintili.",
    position: "P.30 & DNQ",
    highlights: [
      "Douwe: Qualy P.13 • Race 1 P.25 • Race 2 P.26 • Overall P.30",
      "Francesco: Qualy P.31 • Not Qualified for the Races",
      "Tracciato fangoso e impegnativo, Douwe corre con pollice infortunato"
    ]
  }
];

// Race Card Component with Read More functionality
const RaceCard = ({ race, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const MAX_LENGTH = 300;
  
  const shouldTruncate = race.summary.length > MAX_LENGTH;
  const displayText = isExpanded || !shouldTruncate 
    ? race.summary 
    : race.summary.substring(0, MAX_LENGTH) + '...';

  return (
    <article
      className={`flex flex-col ${
        index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
      } gap-8 group`}
    >
      {/* Image(s) */}
      <div className="lg:w-1/2">
        {race.images ? (
          // Multiple images - show stacked vertically
          <div className="flex flex-col gap-4">
            {race.images.map((img, idx) => (
              <div key={idx} className="relative overflow-hidden rounded-2xl">
                <img loading="lazy" decoding="async"
                  src={img}
                  alt={`${race.title} - ${idx + 1}`}
                  className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            ))}
          </div>
        ) : (
          // Single image
          <div className="relative overflow-hidden rounded-2xl">
            <img loading="lazy" decoding="async"
              src={race.image}
              alt={race.title}
              className="w-full h-96 object-cover group-hover:scale-110 transition-transform duration-700"
            />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="lg:w-1/2 flex flex-col justify-center">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl border border-gray-700 hover:border-cyan-500/50 transition-all duration-300">
          <div className="flex items-center gap-3 mb-4 flex-wrap">
            <span className="px-3 py-1 bg-yellow-500 text-black text-xs font-bold rounded-full uppercase">
              {race.category}
            </span>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Calendar className="w-4 h-4" />
              <span>{race.date}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <MapPin className="w-4 h-4" />
              <span>{race.location}</span>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {race.title}
          </h2>

          <p className="text-cyan-400 font-bold mb-4">
            {race.riders.includes(' e ') ? 'Piloti:' : 'Pilota:'} {race.riders}
          </p>

          <div className="text-gray-400 leading-relaxed mb-4">
            <p>{displayText}</p>
            {shouldTruncate && (
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="mt-3 flex items-center gap-2 text-cyan-400 hover:text-cyan-300 font-semibold transition-colors"
              >
                {isExpanded ? (
                  <>
                    <span>Mostra meno</span>
                    <ChevronUp className="w-4 h-4" />
                  </>
                ) : (
                  <>
                    <span>Leggi di più</span>
                    <ChevronDown className="w-4 h-4" />
                  </>
                )}
              </button>
            )}
          </div>

          <div>
            <h3 className="text-white font-bold mb-3 flex items-center gap-2">
              <Trophy className="w-5 h-5 text-yellow-400" />
              Highlights
            </h3>
            <ul className="space-y-2">
              {race.highlights.map((highlight, idx) => (
                <li
                  key={idx}
                  className="flex items-start gap-3 text-gray-400"
                >
                  <Flag className="w-4 h-4 text-cyan-400 mt-1 flex-shrink-0" />
                  <span className="text-sm">{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </article>
  );
};

const Gare = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header logo={teamData.logo} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-6">
              Race <span className="text-cyan-400">Report</span>
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-yellow-400 mx-auto mb-8"></div>
            <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto">
              I migliori momenti delle nostre gare
            </p>
          </div>
        </div>
      </section>

      {/* Race Recaps */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto space-y-16">
            {raceRecaps.map((race, index) => (
              <RaceCard key={race.id} race={race} index={index} />
            ))}
          </div>

          {/* CTA */}
          <div className="mt-20 text-center">
            <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 backdrop-blur-sm p-10 rounded-3xl border border-gray-700/50 max-w-3xl mx-auto">
              <Flag className="w-16 h-16 text-cyan-400 mx-auto mb-6" />
              <h3 className="text-3xl font-bold text-white mb-4">
                Seguici nelle Prossime Gare
              </h3>
              <p className="text-xl text-gray-400 leading-relaxed">
                Resta aggiornato sui risultati e le performance del team durante tutta la stagione 2026!
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer socialMedia={socialMedia} teamName={teamData.name} logo={teamData.logo} />
    </div>
  );
};

export default Gare;
